module.exports = __webpack_public_path__ + "media/standup-turn-notification-sound.d124b8a7.mp3";